import { FieldValue } from './field.class'

export class OptionsetValue extends FieldValue<string> {
  public optionSetName: string
  public description: string

  constructor(value?: string, optName?: string, desc?: string) {
    super()
    this.value = value
    this.optionSetName = optName ?? ''
    this.description = desc ?? ''
  }

  public mapField(field: OptionsetValue): void {
    this.value = field.value
    this.optionSetName = field.optionSetName
    this.description = field.description
  }

  public toStringForView(): string {
    //TODO: check sometimes the back end does not provide a description
    return this.description
  }
}
